export default __webpack_public_path__ + "static/media/2391.edea9c2d.png";